import React, { useContext, useEffect, useState } from 'react';
import AppRouter from './Routes/AppRouter';

import '@/components/ServicesBannersForHome/style.css';
import '@/Shared/common/components/Container/style.css';
import '@/Shared/common/components/SmallRate/style.css';
import '@/components/StoresShowcase/style.css';
import '@/components/GenericFooter/style.css';
import '@/components/GenericFooter/components/MenuLinks/style.css';
import '@/components/DropdownProductFeatures/style.css';
import '@/components/StoresShowcase/components/StoreCarousel/style.css';
import '@/components/StoresShowcase/components/StoreCarousel/components/StoreItem/style.css';
import '@/components/ServicesBannersForHome/components/StaticBannersService/style.css';
import '@/components/ServicesBannersForHome/components/CarouselBannersService/style.css';
import '@vertem-core/vertice-ds/src/Assets/styles/style.css';
import dayjs from 'dayjs';
import advancedFormat from 'dayjs/plugin/advancedFormat';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import localeData from 'dayjs/plugin/localeData';
import weekday from 'dayjs/plugin/weekday';
import weekOfYear from 'dayjs/plugin/weekOfYear';
import weekYear from 'dayjs/plugin/weekYear';
import RootProvider from './structure/RootProvider/RootProvider';
import { WrapperDefault } from './structure';

dayjs.extend(customParseFormat);
dayjs.extend(advancedFormat);
dayjs.extend(weekday);
dayjs.extend(localeData);
dayjs.extend(weekOfYear);
dayjs.extend(weekYear);

import '@vertem-core/vertice-ds/src/Assets/styles/Templates/Marketplace/style.css';
import initialTokensValues from 'Assets/skins/default';
import { VertTokens, VertTokensProvider } from '@vertem-core/vertice-ds';
import { useDispatch, useSelector } from 'react-redux';
import Store from 'redux/store';
import {
  GET_INITIAL_TOKENS,
  GET_INITIAL_TOKENS_FAIL,
  GET_INITIAL_TOKENS_SUCCESS,
} from 'redux/Reducers/Template/TemplateReducer';
import { isObjectEmpty } from 'Utils';
import VertNotificationRefresh from 'components/VetNotification/VertNotificationRefresh';
import { FloatButton } from 'antd';
import { FaMagic } from 'react-icons/fa';
import DrawerStyle from 'components/DrawerStyle';
import useActiveSkinEditor from 'Hooks/useActiveSkinEditor';
import SpotPermissions from 'components/Spot/SpotPermissions';
import useTemplate from 'Hooks/useTemplate';
import { useStorageMonitor } from 'Hooks/useStorageMonitor';
import { decryptGa4Params } from 'redux/Reducers/GA4/GA4Slice';
import { initializeGa4 } from 'Utils/GA4';

const App = () => {
  const dispatch = useDispatch();

  useStorageMonitor();

  const { fetchTemplate } = useTemplate();
  const isActiveEditor = useActiveSkinEditor();
  const [fetchedData, setFetchedData] = useState(null);
  const {updateDesignTokens} = useContext(VertTokens)

  const [initialTokensValuesSkin, setInitialTokensValuesSkin] =
    useState(initialTokensValues);
  const [tokensSkin, setTokensSkin] = useState(0);

  const [open, setOpen] = useState(false);
  const { isLoadingUser } = useSelector((state) => state.oidc);

  const initialTokensValuesExternal = useSelector(({ Template: data }) => data);

  let initialTokensValuesFinal = initialTokensValuesExternal?.data;

  useEffect(() => {
    let isMounted = true;
    Store.dispatch({ type: GET_INITIAL_TOKENS });
    fetchTemplate().then((data) => {
      if (isMounted) {
        const infoTokens = data;

        console.log('infoTokens', infoTokens);
        setFetchedData(infoTokens);


      }
    }).catch((error) => {
      console.error(error);
      setFetchedData(initialTokensValues);

      });

  
  }, [
    isObjectEmpty(initialTokensValuesFinal || {}) &&
      !initialTokensValuesExternal?.isLoading &&
      !initialTokensValuesExternal?.isLoaded &&
      !initialTokensValuesExternal?.isError,
  ]);

  useEffect(() => {
    const encryptedGa4Params = window.localStorage.getItem('ga4EncryptedParams');

    if (!encryptedGa4Params) {
      const urlParams = new URLSearchParams(location.search);
      const ga4 = urlParams.get('gtm');

      if (!ga4) return;

      window.localStorage.setItem('ga4EncryptedParams', ga4);
    }

    dispatch(decryptGa4Params(window.localStorage.getItem('ga4EncryptedParams')))
      .unwrap()
      .then(additionalConfig => initializeGa4(additionalConfig))
  }, []);

  return (
    <React.Fragment>
      <VertTokensProvider
        sharedTemplate="marketplace"
        initialTokens={
          tokensSkin === 1 ? initialTokensValuesSkin : fetchedData
        }
      >
        <RootProvider>
      
          <SpotPermissions>
            <VertNotificationRefresh>
              <WrapperDefault>
                {isActiveEditor && !isLoadingUser && (
                  <>
                    <DrawerStyle
                      open={open}
                      setOpen={setOpen}
                      initialTokens={initialTokensValuesSkin}
                      setInitialTokensValuesSkin={setInitialTokensValuesSkin}
                    />
                    <FloatButton
                      tooltip="Customizar Skin!"
                      icon={<FaMagic />}
                      type="primary"
                      style={{ right: 31, bottom: 107 }}
                      onClick={() => {
                        setOpen(true);
                        setTokensSkin(1);
                      }}
                    />
                  </>
                )}
                <AppRouter />
              </WrapperDefault>
            </VertNotificationRefresh>
          </SpotPermissions>
 
        </RootProvider>
      </VertTokensProvider>
    </React.Fragment>
  );
};

export default App;
